import type { Product } from '../../../data/product';
import { formatDate, formatDateISO } from '../../../helpers/format-date';
import { defineColumn, type StrictColumnDef } from '../../tanstack-table/column';

const today = new Date();

export const LastSold: StrictColumnDef<Product> = defineColumn<Product>({
  id: 'Last Sold',
  minWidth: 50,
  accessorFn: (product) => (product.last_sold ? formatDate(product.last_sold, today) : ' -'),
  sortKeyFn: (product) => product.last_sold,
  toCSV: (product) => ({
    'Last Sold': product.last_sold ? formatDateISO(product.last_sold) : '',
  }),
});
